import { z } from 'zod';
/**
 * Send a form OR a packet to a patient (README §7). Exactly one of formId /
 * packetId. `dueInDays` opens the completion deadline clock.
 */
export const dispatchCreateSchema = z
    .object({
    patientId: z.string().uuid(),
    formId: z.string().uuid().optional(),
    packetId: z.string().uuid().optional(),
    destination: z.enum(['portal', 'queue', 'both']).default('portal'),
    note: z.string().max(1000).nullish(),
    dueInDays: z.number().int().min(0).max(365).nullish(),
})
    .refine((d) => Boolean(d.formId) !== Boolean(d.packetId), {
    message: 'Provide exactly one of formId or packetId',
    path: ['formId'],
});
/**
 * Forms Hub "Schedule Send": the same send, held on the server until `sendAt`, then sent by
 * the worker through the normal dispatch path. `dueDate` is the completion deadline as a
 * calendar date (the send computes dueInDays from it); `assignToId` is carried for the UI.
 */
export const scheduledDispatchSchema = z
    .object({
    patientId: z.string().uuid(),
    formId: z.string().uuid().optional(),
    packetId: z.string().uuid().optional(),
    destination: z.enum(['portal', 'queue', 'both']).default('portal'),
    note: z.string().max(1000).nullish(),
    dueDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD')
        .nullish(),
    sendAt: z.string().datetime({ offset: true }),
    assignToId: z.string().max(64).nullish(),
})
    .refine((d) => Boolean(d.formId) !== Boolean(d.packetId), {
    message: 'Provide exactly one of formId or packetId',
    path: ['formId'],
});
export const SCHEDULED_DISPATCH_STATUSES = ['pending', 'sent', 'cancelled', 'failed'];
/** Whole days from `from` to the calendar date `dueDate` (YYYY-MM-DD, UTC), never negative. */
export function dueInDaysFrom(dueDate, from) {
    if (!dueDate)
        return null;
    const due = Date.parse(dueDate + 'T00:00:00Z');
    if (Number.isNaN(due))
        return null;
    const start = Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), from.getUTCDate());
    return Math.min(365, Math.max(0, Math.round((due - start) / 86_400_000)));
}
//# sourceMappingURL=dispatch.js.map